// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "2398c2500eec4937a45717043eee9b3bb58fda57/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};